import supabase from "artifact/supabase";
import connected from "standard/connected";
import define from "standard/define";
import on from "standard/on";
import paint from "standard/paint";
import repaint from "standard/repaint";
import trait from "standard/trait";
import willPaint from "standard/willPaint";
import style from "./style";

@define("m-students")
class Students extends HTMLElement {
  #users = [];
  #classSelected;
  #valueSearch;
  #result;

  constructor() {
    super();
    this.attachShadow({ mode: "open" });
  }

  @connected
  @paint
  [trait.template]() {
    return `
      <ul class="${style.students}">
        ${this[trait.renderStudents](this.#users)}
      </ul>
    `;
  }

  @connected
  [trait.valueButton]() {
    window.addEventListener("clicked", (event) => {
      this.#classSelected = event.detail.result;
      this[trait.filter]();
    });
  }

  @willPaint
  async [trait.fetch]() {
    const query = supabase
      .from("user")
      .select("*, team!inner(*, type!inner(*))")
      .eq("team.school_id", this.dataset.school)
      .eq("team.type.name", "Student")
      .eq("team.active", true)
      .order("name", { ascending: true })
      .limit(100);

    if (this.#classSelected) {
      query.in("team.class_id", [this.#classSelected].filter(Boolean));
    }

    const { data: users } = await query;

    this.#users = users;
  }

  @connected
  [trait.valueSearch]() {
    window.addEventListener("search", (event) => {
      this.#valueSearch = event.detail.value;
      this[trait.filter]();
    });

    return this;
  }

  [trait.renderStudents](students) {
    return students
      .map(
        (e) => `
      <li class="${style.students__li}">
        <div class="${style.students__informations}">
          <div class="${style.students__name}">${e.name}</div>
          <div class="${style.students__email}">${e.email}</div>
        </div>
        <div class="${style.students__actions}">
          <button class="${style.students__changeButton}" data-user="${e.id}">
            <img class="${style.students__delete}" src="//donna.sistemadulino.com.br/change_password.png" alt="Confirmar" loading="auto" />
          </button>
          <button class="${style.students__deleteButton}" data-user="${e.id}">
            <img class="${style.students__delete}" src="//donna.sistemadulino.com.br/delete.png" alt="Confirmar" loading="auto" />
          </button>
        </div>
      </li>
    `,
      )
      .join("");
  }

  [trait.notFound]() {
    return `
      <hgroup class="${style.notFound}">
        <h2 class="${style.notFound__title}">Nenhum Aluno encontrado</h2>
        <h3 class="${style.notFound__description}">Tente fazer uma nova busca</h3> 
      </hgroup>
    `;
  }

  [trait.filter]() {
    const regex = new RegExp(this.#valueSearch, "ig");

    this.#result = this.#users.filter((e) => {
      return regex.test(e.name);
    });

    this.#result = this.#result.filter((e) => {
      if (!this.#classSelected) return true;
      return e.team[0]?.class_id == this.#classSelected;
    });

    if (this.#result.length != 0) {
      this.shadowRoot.querySelector("ul").innerHTML = this[
        trait.renderStudents
      ](this.#result);
    } else {
      this.shadowRoot.querySelector("ul").innerHTML = this[trait.notFound]();
    }
  }

  @on.click(`button.${style.students__deleteButton}`)
  @repaint
  async [trait.delete](event) {
    const confirmed = window.confirm("Deseja remover aluno?");

    if (confirmed) {
      await supabase
        .from("team")
        .update({ active: false })
        .eq("user_id", event.target.dataset.user)
        .eq("school_id", this.dataset.school);
    }
  }

  @on.click(`button.${style.students__changeButton}`)
  @repaint
  async [trait.changePassword](event) {
    const newPassword = window.prompt("Nova senha:");

    if (newPassword) {
      await supabase;
      const { data: user, error } = await supabase.auth.admin.updateUserById(
        event.target.dataset.user,
        { password: newPassword },
      );
      alert("Sua alteração foi salva com sucesso!");
    }
  }
}

export default Students;
